import React from "react";
import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";
import callCenterImage from "../Assets/service5.jpeg";

const CallCentersEmpowerment = () => {
  return (
    <div>
      <Fixed />
      <div className="bg-gray-100 text-gray-900 pt-20">
        {/* Hero Section */}
        <section
          className="relative w-full h-screen flex items-center justify-center bg-cover bg-center"
          style={{ backgroundImage: `url(${callCenterImage})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 text-center text-white px-6">
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="text-5xl font-extrabold"
            >
              Call Centers & Empowerment
            </motion.h1>
            <p className="mt-4 text-lg max-w-2xl mx-auto">
              Elevating customer experience through innovation, efficiency, and strategic empowerment.
            </p>
          </div>
        </section>

        {/* About Section */}
        <section className="container mx-auto px-6 py-16 flex justify-center">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="bg-white shadow-lg rounded-lg p-8 max-w-4xl text-center"
          >
            <h2 className="text-4xl font-bold text-slate-800">About Call Centers & Empowerment</h2>
            <p className="mt-6 text-lg text-gray-700 leading-relaxed">
              Modern call centers integrate AI-driven technology, cloud-based solutions, and customer analytics to enhance service quality. With empowerment strategies, businesses can train and equip their workforce to deliver superior customer support.
            </p>
          </motion.div>
        </section>

        {/* Key Benefits */}
        <section className="container mx-auto px-6 py-10">
          <motion.h2
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            className="text-4xl font-bold text-center text-slate-800"
          >
            Why Choose Our Call Center Solutions?
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
            {["AI-Driven Support", "Real-Time Analytics", "24/7 Customer Service", "Multi-Channel Communication", "Workforce Training Programs", "Cloud-Based Integration"].map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition border-t-4 border-blue-500"
              >
                <h3 className="text-2xl font-semibold text-blue-600">{benefit}</h3>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Testimonials */}
        <section className="container mx-auto px-6 py-16">
          <h2 className="text-4xl font-bold text-center text-slate-800">Client Success Stories</h2>
          <div className="mt-10 space-y-6 flex flex-col items-center">
            {["Transformed our customer service with AI-driven solutions!", "Improved response times and customer satisfaction.", "Highly efficient and scalable solutions for our global team."].map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                className="bg-white p-6 rounded-lg shadow-md flex items-center justify-center w-full max-w-2xl text-center"
              >
                <span className="text-2xl font-bold text-blue-600">❝</span>
                <p className="text-gray-700 mx-4">{testimonial}</p>
                <span className="text-2xl font-bold text-blue-600">❞</span>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-16 text-center bg-white border-t border-gray-300">
          <div className="container mx-auto px-6">
            <h2 className="text-4xl font-bold text-slate-800">Enhance Your Call Center Today!</h2>
            <p className="text-lg text-gray-700 mt-4">Leverage AI, analytics, and cloud solutions to improve efficiency and customer satisfaction.</p>
          </div>
        </section>
      </div>
      <Footer1 />
    </div>
  );
};

export default CallCentersEmpowerment;
